import { useState } from "react";
import "./CancelForm.scss";

export default function CancelForm({
  onClose,
  selectedOrders,
  handleCancelOrder,
}) {
  const [reason, setReason] = useState("");
  const [selectedReason, setSelectedReason] = useState("Out of stock");
  //console.log("selectedOrders:", selectedOrders);
  const reasonOptions = [
    "Out of stock",
    "Item discontinued",
    "Incorrect listing information",
    "unable to fulfill order",
  ];

  const handleSubmit = () => {
    // Determine final reason
    const finalReason =
      selectedReason === "other" ? reason.trim() : selectedReason;

    if (!finalReason) {
      alert("Please provide a reason for cancellation.");
      return;
    }

    handleCancelOrder(finalReason);
    onClose();
  };

  return (
    <div className="cancelform-container">
      <h2>CANCEL ORDER?</h2>

      <span>Select reason:</span>
      <div className="reason-option-wrapper">
        <select
          className="reason-option-items"
          value={selectedReason}
          onChange={(e) => {
            setSelectedReason(e.target.value);
            setReason(""); // reset custom reason when changing selection
          }}
        >
          {reasonOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
          <option value="other">Other</option>
        </select>
      </div>

      {selectedReason === "other" && (
        <div className="other-wrapper">
          <span>Please specify:</span>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason here..."
          />
        </div>
      )}

      <div className="button-wrapper">
        <button className="cancel" onClick={onClose}>
          Cancel
        </button>
        <button className="submit" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
}
